angular.module('guest')

.controller('OfferConvertGuestController', ['$scope', 'Registration', 'Notification',
    function ($scope, Registration, Notification) {

        $scope.sendConvertGuestMessage = function() {
            Registration.sendConvertGuestEmail({email: $scope.email}).$promise
            .then(function(success) {
                Notification.success('Message sent! Please check your inbox.');
                
            }, function(error) {
                Notification.error('An error occurred.');
            });
        };
    }]);
